import { useState, createContext, useContext } from "react";
const useCategoryCntx = createContext();
const setCategoryCntx = createContext();
export function CategoryCntx({ children }) {
    const [stCategory, setStCategory] = useState(null);
    return (
        <useCategoryCntx.Provider value={stCategory}>
            <setCategoryCntx.Provider value={setStCategory}>
                {children}
            </setCategoryCntx.Provider>
        </useCategoryCntx.Provider>
    )
}
export function UseCategory() {
    return useContext(useCategoryCntx);
}
export function SetCategory() {
    return useContext(setCategoryCntx);
}